import { Tooltip } from "@blueprintjs/core/lib/esm/components/tooltip/tooltip";
import { IDataTableColumn } from "common/views/table/DataTable";
import DateLabel from "core/components/label/DateLabel";
import { Enrollment } from "../entities/Enrollment";

export const firstName: IDataTableColumn<Enrollment, any> = {
	name: "firstName",
	sort: "firstName",
	sortable: false,
	label: {k: "col.firstName", v: "First Name"},
	component: (enrollment) => {
		return (
			<span>
				{enrollment.firstName}
			</span>
		);
	}
};


export const lastName: IDataTableColumn<Enrollment, any> = {
	name: "lastName",
	sort: "lastName",
	sortable: false,
	label: {k: "col.lastName", v: "Last Name"},
	component: (enrollment) => {
		return (
			<span>
				{enrollment.lastName}
			</span>
		);
	}
};

export const enrollment: IDataTableColumn<Enrollment, any> = {
	name: "score",
	sort: "score",
	sortable: false,
	label: {k: "col.score", v: "Score"},
	component: (enrollment) => {
		return (
			<span>
				{`${enrollment.score}/${enrollment.maxScore}`}
			</span>
		);
	}
};

export const startedOn: IDataTableColumn<Enrollment, any> = {
	name: "startedOn",
	sort: "startedOn",
	sortable: false,
	label: {k: "col.startedOn", v: "Started On"},
	component: (enrollment) => {
		if (!enrollment.startedOn) {
			return null;
		}

		return (
			<Tooltip content={<DateLabel value={enrollment.startedOn} />}>
				<DateLabel value={enrollment.startedOn}/>
			</Tooltip>
		);
	}
};

export const dueDate: IDataTableColumn<Enrollment, any> = {
	name: "dueDate",
	sort: "dueDate",
	sortable: false,
	label: {k: "col.dueDate", v: "Due Date"},
	component: (enrollment) => {
		if (!enrollment.dueDate) {
			return null;
		}

		return (
			<Tooltip content={<DateLabel value={enrollment.dueDate} />}>
				<DateLabel value={enrollment.dueDate}/>
			</Tooltip>
		);
	}
};

export const status: IDataTableColumn<Enrollment, any> = {
	name: "enrollmentStatus",
	sort: "enrollmentStatus",
	sortable: false,
	label: {k: "col.enrollmentStatus", v: "Status"},
	component: (enrollment) => {
		return (
			<span>
				{enrollment.status}
			</span>
		);
	}
};

export const completedOn: IDataTableColumn<Enrollment, any> = {
	name: "completedOn",
	sort: "completedOn",
	sortable: false,
	label: {k: "col.completedOn", v: "Completed On"},
	component: (enrollment) => {
		if (!enrollment.completedOn) {
			return null;
		}

		return (
			<Tooltip content={<DateLabel value={enrollment.completedOn} />}>
				<DateLabel value={enrollment.completedOn}/>
			</Tooltip>
		);
	}
};



// WEBPACK FOOTER //
// ./src/panels/testAssignment/fragments/EnrollmentsListFragments.tsx